class AutoFoldSKPanel {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('[data-auto-fold-sk-panel]').forEach((el) => {
            const h1Elements = el.querySelectorAll('h1');

            h1Elements.forEach(h1 => {
                let nextElement = h1.nextElementSibling;
                const panelDiv = document.createElement('div');
                panelDiv.className = 'sk-panel__content';

                // Move the immediate siblings into the panel div
                while (nextElement && nextElement.tagName !== 'H1') {
                    let currentElement = nextElement;
                    nextElement = nextElement.nextElementSibling;
                    panelDiv.appendChild(currentElement);
                }

                // modify the h1 element text to capitalize
                // h1.textContent = h1.textContent.charAt(0).toUpperCase() + h1.textContent.slice(1).toLowerCase();

                // Insert the panel div immediately after the h1
                h1.parentNode.insertBefore(panelDiv, h1.nextSibling);

                // Initially hide the panel
                panelDiv.classList.add('--hidden');

                // Add click event listener to toggle the panel
                h1.addEventListener('click', () => {
                    const isHidden = panelDiv.classList.contains('--hidden');
                    panelDiv.classList.toggle('--hidden', !isHidden);
                    h1.classList.toggle('--active', isHidden);
                    // Add your animation logic here
                });
            });
        })
    }
}

export default AutoFoldSKPanel